import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

import Trustpilot from '../../modules/trustpilot';
import DividerBottom from '../../ui/icons/dividers/bottom';
import DividerTop from '../../ui/icons/dividers/top';
import BPImage from '../../ui/v2/image';

import classes from './metrics.module.css';
import { useAppContext } from '../../providers/app-context';
import dynamic from 'next/dynamic';

const TrustBox = dynamic(() => import('../../modules/trustpilot/new'), { ssr: false });

export type TMetrics = {
  title: string;
  icon: string;
  iconAlt: string;
  description: string;
};

const Metrics: FunctionComponent = () => {
  const { businessValues } = useAppContext();
  const { t } = useTranslation();
  const metrics = t(
    'about:metrics',
    { totalStockAvailable: businessValues.totalStockAvailable.defaultValue },
    {
      returnObjects: true,
    }
  ) as Array<TMetrics>;
  return (
    <section>
      <DividerTop
        className={cx(
          'text-blue-10',
          'w-full',
          'lg:h-16',
          'transform',
          'lg:scale-x-invert'
        )}
      />
      <div className={cx('bg-blue-10')}>
        <div className="container m-auto py-4 lg:py-16 px-4">
          <ul
            className={cx(classes.timeline, 'flex', 'flex-col', 'lg:flex-row')}
          >
            {metrics.map((item) => (
              <li
                key={item.title}
                className={cx(
                  'py-4',
                  'lg:py-0',
                  'grid',
                  'grid-flow-col',
                  'lg:grid-flow-row',
                  'justify-start',
                  'lg:justify-items-center'
                )}
              >
                <h3 className="order-2 lg:order-1 lg:pb-6 px-4 ml-2 lg:ml-0 text-lg font-bold">
                  {item.title}
                </h3>
                <span className={cx('order-1 lg:order-2 row-span-2')}>
                  <BPImage
                    width={60}
                    height={60}
                    src={`${process.env.PUBLIC_PREFIX}${item.icon}`}
                    alt={item.iconAlt}
                  />
                </span>
                <p className="order-3 lg:pt-6 px-4 ml-2 lg:ml-0 lg:text-center">
                  {item.description}
                </p>
              </li>
            ))}
          </ul>
        </div>
        <DividerBottom
          className={cx(
            'text-neutral-10',
            'w-full',
            'lg:h-7',
            'transform',
            'scale-y-invert',
            'scale-x-invert'
          )}
        />
      </div>
      <div className="bg-neutral-10">
        <div className={cx('py-8 lg:py-6')}>
          <div className={cx('container', 'mx-auto', 'text-center')}>
            <TrustBox />
          </div>
        </div>
        <DividerBottom
          className={cx(
            'text-white',
            'w-full',
            'lg:h-7',
            'transform',
            'scale-y-invert',
            'hidden',
            'lg:block'
          )}
        />
      </div>
      <DividerBottom
        className={cx(
          'text-neutral-10',
          'w-full',
          'lg:hidden',
          'transform',
          'scale-x-invert'
        )}
      />
    </section>
  );
};

export default Metrics;
